import React, { useMemo } from "react";

import { ApiResult } from "../../../rest/baseApi";
import { ExportButton } from "../../shared/ExportButton";
import { useApi } from "../../useApi";

interface Props {
    dealerId: number | undefined,
    orgId: number | undefined,
}

export function SitesExportButton({ dealerId, orgId }: Props) {
    const { siteApi } = useApi();

    const apiRequest: (() => Promise<ApiResult<{ csvData: string; }>>) | undefined = useMemo(() => {
        let apiMethod;
        if (orgId && dealerId) {
            apiMethod = () => siteApi.exportSitesForOrg(dealerId, orgId);
        } else if (dealerId) {
            apiMethod = () => siteApi.exportSitesForDealer(dealerId);
        }
        return apiMethod;
    }, [
        siteApi,
        orgId,
        dealerId,
    ]);

    return (
        <ExportButton
            apiRequest={apiRequest}
            targetLabel="Sites Report"
            buttonLabel="Export Report"
        />
    );
}
